module.exports = __webpack_public_path__ + "img/wow-phone-1.7e735eec.png";